import React from "react";
import PropTypes from "prop-types";
import { LoadingScreen2 } from "@qgiv/core-donor";
import SearchRow from "./SearchRow";
import ConnectedResultsTotal from "./ConnectedResultsTotal";
import ConnectedNoResults from "./ConnectedNoResults";
import ModalStateContext from "../../ModalStateContext";
import "./SearchResults.scss";

const SearchResults = ({ registrations = [] }) => {
    const { isSearching, results } = React.useContext(ModalStateContext);
    // check number of registrations against team limits
    const teamsOnRegistrations = registrations
        // filter out registrations without team data
        .filter(
            (registration) =>
                Object.keys(registration).length > 0 &&
                registration.Team !== "",
        )
        // keep only id of the team on the registration
        .map((registration) => registration.Team)
        // reduce to number of times a team exists in registrations
        .reduce((teamsObj, team) => {
            if (team in teamsObj) {
                // eslint-disable-next-line no-param-reassign
                teamsObj[team]++;
            } else {
                // eslint-disable-next-line no-param-reassign
                teamsObj[team] = 1;
            }
            return teamsObj;
        }, {});

    const teamsRemainingSpotsMap = (team) => {
        // teams without classification team registrant limits will not have remainingSpots property
        // set remainingSpots to -1
        if (team.remainingSpots === undefined) {
            return {
                ...team,
                remainingSpots: -1,
            };
        }

        const teamId = String(team.id);
        if (
            // there are some teams on registrations
            Object.keys(teamsOnRegistrations).length > 0 &&
            // this particular team exists in map
            teamsOnRegistrations[teamId] !== undefined
        ) {
            const newRemainingSpots =
                team.remainingSpots - teamsOnRegistrations[teamId];
            return {
                ...team,
                remainingSpots: newRemainingSpots > 0 ? newRemainingSpots : 0,
            };
        }
        return team;
    };

    const teamsToDisplay = results.map(teamsRemainingSpotsMap);

    return (
        <>
            <div className="col col--12">
                <ConnectedResultsTotal total={teamsToDisplay.length} />
            </div>
            <div className="col col--12 col--no-top-gutter">
                <div className="team-modal-search-results">
                    {isSearching ? (
                        <LoadingScreen2 active />
                    ) : (
                        <div className="grid">
                            <div className="col col--12 col--no-top-gutter">
                                {teamsToDisplay.length > 0 ? (
                                    <div className="grid">
                                        {teamsToDisplay.map((team) => {
                                            const {
                                                captains = [],
                                                id,
                                                remainingSpots = -1,
                                                title,
                                            } = team;
                                            const teamFull =
                                                remainingSpots === 0;
                                            const searchRowProps = {
                                                captains,
                                                id,
                                                teamFull,
                                                title,
                                            };
                                            return (
                                                <SearchRow
                                                    key={id}
                                                    {...searchRowProps}
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <ConnectedNoResults />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

SearchResults.propTypes = {
    registrations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default SearchResults;
